export const by = <T>(callback: (value: T) => number | string, largestFirst = false): ((valueA: T, valueB: T) => number) => {
  return (valueA: T, valueB: T) => {
    if (callback(valueA) < callback(valueB)) return largestFirst ? 1 : -1
    if (callback(valueA) > callback(valueB)) return largestFirst ? -1 : 1
    return 0
  }
}